import { render } from "./PersonalData.vue?vue&type=template&id=40049422&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"

import "./PersonalData.vue?vue&type=style&index=0&id=40049422&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40049422"]])

export default __exports__